import React from "react";
import PropTypes from "prop-types";

import { Container, Row, Col } from "reactstrap";

import { formatNumber } from "../../../utils/index";
import TimeRange from "../../Components/TimeRange";

import "./OverviewEntry.scss";
import "./LogdevsOverview.scss";

const COLUMNS_LEFT = 4;
const COLUMNS_RIGHT = 8;

const OverviewEntry = (props) => {
  const { columnsLeft, columnsRight, label, value } = props;

  return (
    <Row className="resources-overview-entry">
      <Col xs={columnsLeft} className="overview-entry-left">
        {value}
      </Col>

      <Col xs={columnsRight} className="overview-entry-right">
        {label}
      </Col>
    </Row>
  );
};

OverviewEntry.propTypes = {
  columnsLeft: PropTypes.number,
  columnsRight: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

OverviewEntry.defaultProps = {
  columnsLeft: COLUMNS_LEFT,
  columnsRight: COLUMNS_RIGHT,
  label: "",
  value: "",
};

const LogdevsOverview = (props) => {
  const { columnsLeft, columnsRight, overview } = props;

  const {
    deviceCount,
    eps,
    logEventCount,
    logTypeCount,
    sensorCount,
    dates = {},
  } = overview;
  const { windowEnd = "", windowStart = "" } = dates;

  const epsStr = Number.isNaN(eps) ? eps : formatNumber(eps, 0);

  return (
    <div className="resources-logdev-overview dark">
      <div className="resources-overview-title">
        <div>Summary</div>

        <div className="resources-overview-subtitle">
          <TimeRange
            dateEnd={windowEnd}
            dateStart={windowStart}
            dateFormatStr="L"
            prefix=""
            showTz={false}
          />
        </div>
      </div>

      <Container>
        <OverviewEntry
          columnsLeft={columnsLeft}
          columnsRight={columnsRight}
          label="Log Events"
          value={formatNumber(logEventCount, 0)}
        />

        <OverviewEntry
          columnsLeft={columnsLeft}
          columnsRight={columnsRight}
          label="Events per Second"
          value={epsStr}
        />

        <OverviewEntry
          columnsLeft={columnsLeft}
          columnsRight={columnsRight}
          label="Log Types"
          value={formatNumber(logTypeCount, 0)}
        />

        <OverviewEntry
          columnsLeft={columnsLeft}
          columnsRight={columnsRight}
          label="Active Blumira Sensors"
          value={formatNumber(sensorCount, 0)}
        />

        <OverviewEntry
          columnsLeft={columnsLeft}
          columnsRight={columnsRight}
          label="Active Logging Devices"
          value={formatNumber(deviceCount, 0)}
        />
      </Container>
    </div>
  );
};

LogdevsOverview.propTypes = {
  columnsLeft: PropTypes.number,
  columnsRight: PropTypes.number,
  overview: PropTypes.shape({}),
  dates: PropTypes.shape({}),
};

LogdevsOverview.defaultProps = {
  columnsLeft: COLUMNS_LEFT,
  columnsRight: COLUMNS_RIGHT,
  overview: {},
  dates: {},
};

export default LogdevsOverview;
